export default "__VITE_ASSET__BK9bYdBb__"